import React from "react";
import { useEntitlement } from "../lib/entitlement";
import { isProActive } from "../lib/featureAccess";
import UpgradeScreen from "./UpgradeScreen";

/**
 * RequireProAccess — route wrapper that hard-walls a route for Preview /
 * unauthenticated users. Renders the children only when the entitlement
 * grants RigSentinel Pro. Otherwise shows the standard UpgradeScreen.
 * Fails closed on entitlement load failure.
 */
export default function RequireProAccess({ children, context }) {
  const ent = useEntitlement();
  // While the initial entitlement load is in flight, render nothing rather
  // than briefly leaking the protected UI. UpgradeScreen will appear once
  // the load resolves (or instantly if cached as Preview).
  if (ent.loading) return null;
  if (!isProActive(ent)) return <UpgradeScreen context={context} />;
  return children;
}
